import React, { createContext, useCallback, useEffect, useRef, useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Typography,
} from "@material-ui/core";

export const NavigationBlockerContext = createContext(null);

export const NavigationBlockerProvider = ({ children, confirmRef }) => {
  const blockerRef = useRef(null);
  const [modal, setModal] = useState({ open: false, callback: null });

  const setBlocker = useCallback((blocker) => {
    blockerRef.current = blocker;
  }, []);

  const getUserConfirmation = useCallback((message, callback) => {
    const blocker = blockerRef.current;
    if (blocker && typeof blocker.isDirty === "function" && blocker.isDirty()) {
      setModal({ open: true, callback });
    } else {
      callback(true);
    }
  }, []);

  useEffect(() => {
    if (confirmRef) confirmRef.current = getUserConfirmation;
    return () => {
      if (confirmRef) confirmRef.current = null;
    };
  }, [getUserConfirmation, confirmRef]);

  const handleSave = useCallback(async () => {
    const blocker = blockerRef.current;
    setModal((m) => {
      if (blocker && typeof blocker.onSave === "function") {
        blocker.onSave().then((ok) => {
          if (m.callback) m.callback(ok);
        });
      } else if (m.callback) {
        m.callback(true);
      }
      return { open: false, callback: null };
    });
  }, []);

  const handleDiscard = useCallback(() => {
    setModal((m) => {
      if (m.callback) m.callback(true);
      return { open: false, callback: null };
    });
  }, []);

  const handleCancel = useCallback(() => {
    setModal((m) => {
      if (m.callback) m.callback(false);
      return { open: false, callback: null };
    });
  }, []);

  return (
    <NavigationBlockerContext.Provider value={{ setBlocker, getUserConfirmation }}>
      {children}
      <Dialog open={modal.open} onClose={handleCancel} disableEscapeKeyDown={false}>
        <DialogTitle>Unsaved changes</DialogTitle>
        <DialogContent>
          <Typography variant="body2">
            You have unsaved changes. Do you want to save before leaving?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancel} color="default">
            Cancel
          </Button>
          <Button onClick={handleDiscard} color="default">
            Discard
          </Button>
          <Button onClick={handleSave} color="primary" variant="contained">
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </NavigationBlockerContext.Provider>
  );
};
